module.exports.Languages = {
  PORTUGUESE: 'pt',
  SPANISH: 'es',
  ENGLISH: 'en'
}
